import React,{useState,useEffect,useCallback}from'react';
import{FolderOpen}from'lucide-react';
import{theme}from'./theme';
import{apiCall}from'./api';
import{FileRow,FileListHeader,EmptyState,ErrorBanner}from'./components';
export default function FilesScreen({token,searchQuery,onShare,onProfileRefresh,reloadSignal}){
  const[files,setFiles]=useState([]);
  const[loading,setLoading]=useState(true);
  const[error,setError]=useState('');
  const load=useCallback(async()=>{setLoading(true);setError('');try{const d=await apiCall('/files',token);setFiles(Array.isArray(d)?d:[]);}catch(e){setError(e.message);}finally{setLoading(false);};},[token]);
  useEffect(()=>{load();},[load,reloadSignal]);
  const handleDownload=async(item)=>{try{const res=await fetch(`https://api.shodashienterprise.in/api/files/${item.id}/download`,{headers:{Authorization:`Bearer ${token}`}});const blob=await res.blob();const url=window.URL.createObjectURL(blob);const a=document.createElement('a');a.href=url;a.download=item.fileName;a.click();window.URL.revokeObjectURL(url);}catch{setError('Download failed');}};
  const handleDelete=async(item)=>{try{await apiCall(`/files/${item.id}`,token,{method:'DELETE'});load();onProfileRefresh?.();}catch(e){setError(e.message);}};
  const handleFavorite=async(item)=>{try{await apiCall(`/files/${item.id}/favorite`,token,{method:'POST'});load();}catch(e){setError(e.message);}};
  const filtered=searchQuery?files.filter(f=>f.fileName?.toLowerCase().includes(searchQuery.toLowerCase())):files;
  return<div style={{padding:24}}>
    <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:16}}>
      <h2 style={{color:theme.text,fontSize:17,fontWeight:500,margin:0}}>My Files</h2>
      <span style={{color:theme.textFaint,fontSize:12}}>{filtered.length} items</span>
    </div>
    <ErrorBanner message={error}/>
    <div style={{border:`1px solid ${theme.border}`,borderRadius:theme.radius,overflow:'hidden'}}>
      <FileListHeader/>
      {loading?<p style={{color:theme.textFaint,fontSize:12.5,padding:20}}>Loading…</p>:filtered.length===0?<EmptyState icon={FolderOpen} label="No files yet — upload to get started"/>:
        filtered.map(item=><FileRow key={item.id} item={item} onDownload={handleDownload} onDelete={handleDelete} onShare={onShare} onFavorite={handleFavorite}/>)}
    </div>
  </div>;
}
